import { CreateApi } from "../../CreateApi";
import { Methods, Urls } from "../../../common/Utils/ApiConstants";

const reAllocationRequestCollection = CreateApi.injectEndpoints({
  endpoints: (builder) => ({
    getReportedByMeRequestData: builder.query({
      query: (pageNo) => {
        return {
          url: Urls.getReportedByMeTaskList,
          method: Methods.get,
          params: { pageNo },
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),
  }),
});
export const { useLazyGetReportedByMeRequestDataQuery } =
  reAllocationRequestCollection;
